import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { getImageSrc } from '../screens/NewProductUI/ProductDetails';

export default function ImagePreviewSlider({
  title = '',
  imagesList,
  photoIndex,
  setIsOpen,
  setPhotoIndex,
  footer = '',
  handleToggleScreen = () => {},
  pass,
  setPass,
  infiniteLoop = true, // Show first image after last image or last image before first image
}) {
  if (!imagesList || !imagesList.length) return null;
  return (
    <Lightbox
      wrapperClassName="productDetails_lightbox_wrapper"
      mainSrc={getImageSrc(imagesList[photoIndex], pass)}
      nextSrc={ !infiniteLoop && photoIndex === imagesList.length - 1 ? null : getImageSrc(imagesList[(photoIndex + 1) % imagesList.length], pass)}
      prevSrc={ !infiniteLoop && photoIndex === 0 ? null : getImageSrc(
        imagesList[(photoIndex + imagesList.length - 1) % imagesList.length], pass
      )}
      onCloseRequest={() => {
        if (window?.document?.fullscreen || window.fullscreen) {
          handleToggleScreen?.();
        }
        setIsOpen(false);

        let _pass = {};
        Object.keys(pass)?.forEach(
          (_item) => (_pass[_item] = { ...pass[_item], current: pass[_item].default })
        );
        setPass(_pass);

      }}
      onMovePrevRequest={() => {
        setPhotoIndex((photoIndex + imagesList.length - 1) % imagesList.length);
      }}
      onMoveNextRequest={() => {
        setPhotoIndex((photoIndex + 1) % imagesList.length);
      }}
      imageCaption={footer || ''}
      imageTitle={title || ''}
    />
  );
}
